var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.009 10.462H16V12.462H18.009V10.462Z",
    fill: "#16A34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 0.711975H5.25V6.71198H1C0.585786 6.71198 0.25 7.04776 0.25 7.46198V17.462C0.25 17.8762 0.585786 18.212 1 18.212H5.25V21.462C5.25 21.8762 5.58579 22.212 6 22.212H16C16.4142 22.212 16.75 21.8762 16.75 21.462V18.212H21C21.4142 18.212 21.75 17.8762 21.75 17.462V7.46198C21.75 7.04776 21.4142 6.71198 21 6.71198H16.75V0.711975ZM5.25 15.462V16.712H1.75V8.21198H20.25V16.712H16.75V15.462C16.75 15.0478 16.4142 14.712 16 14.712H6C5.58579 14.712 5.25 15.0478 5.25 15.462ZM15.25 6.71198V2.21198H6.75V6.71198H15.25ZM6.75 16.212V20.712H15.25V16.212H6.75Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinting);
export default __webpack_public_path__ + "static/media/printing.722c776b83927e963f108c2fa2ad07c4.svg";
export { ForwardRef as ReactComponent };